import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CheDoBaoCao {
  name: string;
  api_token: string;
}

export interface CheDoBaoCaoListInfor {
  errors: unknown;
  video: CheDoBaoCao;
  isAuthenticated: boolean;
}

@Module
export default class VideoModule
  extends VuexModule
  implements CheDoBaoCaoListInfor
{
  errors = {};
  video = {} as CheDoBaoCao;
  isAuthenticated = !!JwtService.getToken();

  get cheDoBaoCaos() {
    return this.cheDoBaoCaoListData;
  }

  @Mutation
  [Mutations.CHEDO_BAOCAO_LIST_DATA](cheDoBaoCaos) {
    this.cheDoBaoCaoListData = cheDoBaoCaos;
  }

  @Action
  [Actions.CHEDO_BAOCAO_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("chedo_baocaos/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.CHEDO_BAOCAO_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHEDO_BAOCAO_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("chedo_baocaos", payload)
        .then((data) => {
          this.context.commit(Mutations.CHEDO_BAOCAO_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHEDO_BAOCAO_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/chedo_baocaos",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.CHEDO_BAOCAO_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CHEDO_BAOCAO_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/chedo_baocaos", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.CHEDO_BAOCAO_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
